<template>
    <Forms ref="frmSearch"
            title="Busca por Cadastro"
            :showHelp="true"
            :showClearButton="true"
            :showSearchButton="true"
            :showNewButton="true"
            :ShowFooterImbo="true"
            v-on:Clear="onClearSection"
            v-on:Search="Search"
            >
            <div class="form-inputs">
                <label class="labelsearch">Código da APR</label>
                    <b-input placeholder="Informe o código da APR"  v-model="formSearch.codigo"/>
            </div>
            <div class="form-inputs">
                <label class="labelsearch">Status</label>
                <select v-model="formSearch.status" class="form-control">
                  <option :value="null" disabled>Selecione um status</option>
                  <option v-for="data in statusApr" :key="data.value" :value="data.value">{{data.text}}</option>
                </select>
            </div>
            <div class="form-inputs">
                <label class="labelsearch">Local</label>
                    <b-input placeholder="Informe o local" v-model="formSearch.local"/>
            </div>
            <div class="form-inputs">
                <label class="labelsearch">Obra</label>
                    <b-input placeholder="Informe a referência da obra" v-model="formSearch.obra"/>
            </div>
            <div class="form-inputs">
                <label class="labelsearch">Matriz de Risco</label>
                <select  class="form-control" v-model="formSearch.matriz">
                    <option :value="null" disabled>Selecione um tipo de Matriz</option>
                    <option v-for="data in classificacaoRisco" :key="data.value" :value="data.value">{{data.text}}</option>
                </select>
            </div>
            <div class="form-inputs">
                <label class="labelsearch">Data de Envio</label>
                <div class="d-flex align-items-end" >
                    <b-form-datepicker
                        ref = "DataInicio"
                        placeholder="__/__/__"
                        locale="pt-BR"
                        v-model="formSearch.dataInicio"
                        :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                    ></b-form-datepicker>
                    <label class="labelseach ml-1 mr-1" > à </label>
                    <b-form-datepicker
                        placeholder="__/__/__"
                        locale="pt-BR"
                        v-model="formSearch.dataFim"
                        :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                    ></b-form-datepicker>
                </div>
            </div>
    </Forms>
    </template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
import AprAnalisePreliminarRisco from '@/shared/http/repositories/business/aprInquery'
import { loading } from '@/shared/utils/UIHelper'
import Roles from '@/shared/utils/roles.js'

export default {
  name: 'templateFilter',
  components: {AutocompleteZ},
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
      roles: Roles,
      formSearch: {
        codigo: null,
        status: null,
        local: null,
        obra: null,
        matriz: null,
        dataInicio: null,
        dataFim: null,
        isTechnical: false
      },
      statusApr: [],
      matrizApr: [],
      classificacaoRisco: [
        {
          text: 'TOLERÁVEL',
          value: 0
        },
        {
          text: 'MODERADO',
          value: 1
        },
        {
          text: 'NÃO-TOLERÁVEL',
          value: 2
        }
      ]
    }
  },
  mounted () {
    this.GetStatusApr()
    if (this.hasRole(this.roles.APR_RESEARCH_TECHNICIAN_VIEW)) {
      this.formSearch.isTechnical = true
    }
  },
  methods: {
    Search () {
      this.$emit('search', {
        CodigoAtividade: this.formSearch.codigo,
        StatusAPR: this.formSearch.status,
        Local: this.formSearch.local,
        RefereciaObra: this.formSearch.obra,
        RiscoClassificacao: this.formSearch.matriz,
        DataExecucaoAPRInicio: this.formSearch.dataInicio,
        DataExecucaoAPRFinal: this.formSearch.dataFim,
        IsTechnical: this.formSearch.isTechnical
      })
    },
    onClearSection () {
      this.formSearch.codigo = null
      this.formSearch.status = null
      this.formSearch.local = null
      this.formSearch.obra = null
      this.formSearch.matriz = null
      this.formSearch.dataInicio = null
      this.formSearch.dataFim = null
    },
    GetStatusApr () {
      loading.push()
      AprAnalisePreliminarRisco.GetAllStatusApr()
        .then((Response) => {
          loading.pop()
          this.statusApr = [...Response.data]
        })
        .catch((Error) => {
          console.error(Error)
        })
    }
  }
}

</script>

    <style scoped>
    .form-inputs{
        width: 100%;
        padding: 0.5rem 0;
    }
    .labelsearch{
        font-weight: 700;
        color: #666;
        font-size: 14px;
        margin-bottom: 5px;
        padding-bottom: 0;
        font-family: 'Segoe UI';
    }
    </style>



// WEBPACK FOOTER //
// src/views/private/apr/inqueryApr/components/inqueryFilter/inqueryFilter.vue